import Meeting from '../pages/meetings/Meeting'
import Employment from '../pages/candidates/myscr/Employment'
import ProfileInformation from '../pages/candidates/myscr/ProfileInformation'
import SafeguardingRecords from '../pages/candidates/myscr/SafeguardingRecords'
import TrainingRecords from '../pages/candidates/myscr/TrainingRecords'
import Policy from '../pages/policy/policy'
import Tracking from '../pages/policy/Tracking'
import Training from '../pages/training/Training'
import Whistleblowing from '../pages/whistleblowing/Whistleblowing'
import Policies from '../pages/candidates/policies/Policies'
import Incidents from '../pages/incidents/Incidents'
import MyScrRecords from '../pages/myscr-records/MyScrRecords'
import Partners from '../pages/partners/partners'
import Resources from '../pages/resources/Resources'
import IncidentsCandidate from '../pages/candidates/incidents/IncidentsCandidate'
import WhistleblowingCandidate from '../pages/candidates/whistleblowing/WhistleblowingCandidate'
import CandidateResources from '../pages/candidates/resources/CandidateResources'
import CenteralRecords from '../pages/centeral-records/CenteralRecords'
import CandidateSettings from '../pages/candidates/settings/CandidateSettings'
import Settings from '../pages/settings/Settings'
import IncidentLead from '../pages/lead/incidents/IncidentLead'
import WhistleblowingLead from '../pages/lead/whistleblowing/WhistleblowingLead'
// import Dashboard from '../pages/home/Dashboard'
// import Home from '../pages/home/Home'
import Schools from '../pages/super/Schools'
import Dashboard from '../pages/home/Dashboard'
import SuperSetting from '../pages/super/settings/SuperSetting'
import Users from '../pages/super/Users'
import CenteralRecordsGroupGovernor from '../pages/GroupGovernor/CentralRecordsGroupGovernor'
import IncidentGroupGovernor from '../pages/GroupGovernor/lead/incidents/IncidentGroupGovernor'
import WhistleblowingGroupGovernor from '../pages/GroupGovernor/lead/whistleblowing/WhistleblowingGroupGovernor'
import { useAuth } from '../context/AuthContext'

interface Item {
  name: string
  path: string
  component: () => JSX.Element
  // [key: string]: any // Allow other properties
}
interface routeItem {
  label: string
  name: string
  logo: string
  path: string
  hasChild: boolean
}
const filterItemsByPermissions = (
  items: Item[],
  permissions: string[]
): Item[] => {
  const alwaysInclude = ['Default', 'Settings', 'My SCR']

  return items.filter(
    (item) =>
      permissions.includes(item.name) || alwaysInclude.includes(item.name)
  )
}
const filterRouteItemsByPermissions = (
  items: routeItem[],
  permissions: string[]
): routeItem[] => {
  return items.filter((item) => permissions.includes(item.label))
}
// const getStoredPermissions = (): string[] => {
//   const permissions = sessionStorage.getItem('userPermissions')
//   return permissions ? JSON.parse(permissions) : [] // Return an empty array if no permissions are found
// }

// const storedPermissions = getStoredPermissions()

const routesGroupGovernor = [
  { name: 'Home', path: '/home', component: Dashboard },
  { name: 'SCR', path: '/home/scr', component: CenteralRecordsGroupGovernor },
  { name: 'Settings', path: '/home/settings', component: SuperSetting },

  {
    name: 'Whistle Blowing',
    path: '/home/whistleblowing',
    component: WhistleblowingGroupGovernor,
  },
  {
    name: 'Incidents',
    path: '/home/incidents',
    component: IncidentGroupGovernor,
  },
  {
    name: 'My SCR',
    path: '/home/my-scr-record',
    component: MyScrRecords,
  },

  { name: 'Default', path: '*', component: Dashboard }, // Default route
]
const routesSuper = [
  { path: '/home', component: Partners },

  { path: '/home/settings', component: SuperSetting },

  { path: '/home/schools', component: Schools },
  { path: '/home/Users', component: Users },

  { path: '*', component: Partners }, // Default route
]
const routesAdmin = [
  { name: 'Home', path: '/home', component: Dashboard },

  // { path: '/home', component: Home },
  { name: 'Settings', path: '/home/settings', component: Settings },
  { name: 'SCR', path: '/home/scr', component: CenteralRecords },
  { name: 'Policy', path: '/home/policyManager', component: Policy },
  { name: 'Policy', path: '/home/tracking', component: Tracking },
  { name: 'Training Records', path: '/home/training', component: Training },
  { name: 'Meetings', path: '/home/meeting', component: Meeting },
  {
    name: 'Whistle Blowing',
    path: '/home/whistleblowing',
    component: Whistleblowing,
  },
  { name: 'Incidents', path: '/home/incidents', component: Incidents },
  {
    name: 'My SCR',
    path: '/home/my-scr-record',
    component: MyScrRecords,
  },
  // { name: 'Partners', path: '/home/partners', component: Partners },
  { name: 'Resources', path: '/home/resources', component: Resources },
  // { name: 'Schools', path: '/home/schools', component: Schools },
  { name: 'Default', path: '*', component: Dashboard }, // Default route
]
const routesLead = [
  { name: 'Home', path: '/home', component: Dashboard },
  { name: 'Settings', path: '/home/settings', component: Settings },
  { name: 'SCR', path: '/home/scr', component: CenteralRecords },
  { name: 'Policy', path: '/home/policyManager', component: Policy },
  { name: 'Policy', path: '/home/tracking', component: Tracking },
  { name: 'Training Records', path: '/home/training', component: Training },
  { name: 'Meetings', path: '/home/meeting', component: Meeting },
  {
    name: 'Whistle Blowing',
    path: '/home/lead/whistleblowing',
    component: WhistleblowingLead,
  },
  { name: 'Incidents', path: '/home/lead/incidents', component: IncidentLead },
  { name: 'My SCR', path: '/home/my-scr-record', component: MyScrRecords },
  // { path: '/home/partners', component: Partners },
  { name: 'Resources', path: '/home/resources', component: Resources },
  { name: 'Default', path: '*', component: Dashboard }, // Default route
]
const routesUser = [
  // { path: '/home', component: Home },
  {
    name: 'My SCR',
    path: '/home',
    component: ProfileInformation,
  },
  { name: 'Settings', path: '/home/settings', component: CandidateSettings },
  {
    name: 'My SCR',
    path: '/home/candidate/employment',
    component: Employment,
  },
  {
    name: 'My SCR',
    path: '/home/candidate/safeguarding-records',
    component: SafeguardingRecords,
  },
  {
    name: 'My SCR',
    path: '/home/candidate/training-records',
    component: TrainingRecords,
  },
  { name: 'Policy', path: '/home/candidate/policies', component: Policies },
  {
    name: 'Incidents',
    path: '/home/candidate/incidents',
    component: IncidentsCandidate,
  },
  {
    name: 'Whistle Blowing',
    path: '/home/candidate/Whistleblowing',
    component: WhistleblowingCandidate,
  },
  {
    name: 'Resources',
    path: '/home/candidate/Resources',
    component: CandidateResources,
  },
  { name: 'Default', path: '*', component: ProfileInformation }, // Default route
]

const returnRouter = (role: string | undefined | null) => {
  const { userPermissions } = useAuth()

  let route

  if (role == 'Admin' || role == 'Group Admin') {
    route = filterItemsByPermissions(routesAdmin, userPermissions)
    return route
  } else if (role == 'Staff' || role == 'Group Staff') {
    route = filterItemsByPermissions(routesUser, userPermissions)
    return route
  } else if (
    role == 'DSL' ||
    role == 'Admin / DSL' ||
    role == 'Group DSL' ||
    // role == 'Group Admin' ||
    role == 'Group Admin / DSL'
  ) {
    // route = routesLead
    route = filterItemsByPermissions(routesLead, userPermissions)
    return route
  } else if (role == 'super') {
    route = routesSuper
    return route
  } else if (role == 'Group Governor' || role == 'Governor') {
    route = filterItemsByPermissions(routesGroupGovernor, userPermissions)
    return route
  }

  return route || [] // Return an empty array if no route is found
}

export { returnRouter }

export const SideBarAdminItems = [
  {
    label: 'Home',
    name: 'Home',
    logo: 'IconHomeInActive',
    path: '/home',
    hasChild: false,
  },

  {
    label: 'SCR',
    name: 'Single Central Record',
    logo: 'IconFolderInActive',
    path: '/home/scr',
    hasChild: false,
  },
  {
    label: 'Policy',
    name: 'Policy Manager',
    logo: 'IconFileCheckInActive',
    path: '/home/policyManager',
    hasChild: true,
    child: [
      {
        name: 'Policy Manager',
        logo: 'IconFileCheckInActive',
        path: '/home/policyManager',
      },
      {
        name: 'Tracking',
        logo: 'IconFileCheckInActive',
        path: '/home/tracking',
      },
    ],
  },

  {
    label: 'Training Records',
    name: 'Training Records',
    logo: 'IconGraduationHatInActive',
    path: '/home/training',
    hasChild: false,
  },
  {
    label: 'Meetings',
    name: 'Meetings',
    logo: 'IconMessageChatSquareInActive',
    path: '/home/meeting',
    hasChild: false,
  },
  {
    label: 'Incidents',
    name: 'Incidents',
    logo: 'IconAlertTriangleInActive',
    path: '/home/incidents',
    hasChild: false,
  },
  {
    label: 'Whistle Blowing',
    name: 'Whistleblowing',
    logo: 'IconAnnotationAlertInActive',
    path: '/home/whistleblowing',
    hasChild: false,
  },
  {
    label: 'Resources',
    name: 'Resources',
    logo: 'IconToolInActive',
    path: '/home/resources',
    hasChild: false,
  },
]
export const SideBarLeadItems = [
  {
    label: 'Home',
    name: 'Home',
    logo: 'IconHomeInActive',
    path: '/home',
    hasChild: false,
  },

  {
    label: 'SCR',
    name: 'Single Central Record',
    logo: 'IconFolderInActive',
    path: '/home/scr',
    hasChild: false,
  },
  {
    label: 'Policy',
    name: 'Policy Manager',
    logo: 'IconFileCheckInActive',
    path: '/home/policyManager',
    hasChild: true,
    child: [
      {
        name: 'Policy Manager',
        logo: 'IconFileCheckInActive',
        path: '/home/policyManager',
      },
      {
        name: 'Tracking',
        logo: 'IconFileCheckInActive',
        path: '/home/tracking',
      },
    ],
  },

  {
    label: 'Training Records',
    name: 'Training Records',
    logo: 'IconGraduationHatInActive',
    path: '/home/training',
    hasChild: false,
  },
  {
    label: 'Meetings',
    name: 'Meetings',
    logo: 'IconMessageChatSquareInActive',
    path: '/home/meeting',
    hasChild: false,
  },
  {
    label: 'Incidents',
    name: 'Incidents',
    logo: 'IconAlertTriangleInActive',
    path: '/home/lead/incidents',
    hasChild: false,
  },
  {
    label: 'Whistle Blowing',
    name: 'Whistleblowing',
    logo: 'IconAnnotationAlertInActive',
    path: '/home/lead/whistleblowing',
    hasChild: false,
  },
  {
    label: 'Resources',
    name: 'Resources',
    logo: 'IconToolInActive',
    path: '/home/resources',
    hasChild: false,
  },
]
export const SideBarSuperItems = [
  {
    name: 'Partners',
    logo: 'IconHomeInActive',
    path: '/home',
    hasChild: false,
  },

  {
    name: 'Schools',
    logo: 'IconGraduationHatInActive',
    path: '/home/schools',
    hasChild: false,
  },
  {
    name: 'Users',
    logo: 'IconGraduationHatInActive',
    path: '/home/Users',
    hasChild: false,
  },
]
export const SideBarCandidateItems = [
  // { name: 'Home', logo: 'IconHomeInActive', path: '/home', hasChild: false },
  {
    label: 'Home',
    name: 'My SCR',
    logo: 'IconFolderInActive',
    path: '/home',
    hasChild: true,
    child: [
      {
        name: 'Profile Information',
        logo: '',
        path: '/home',
      },
      {
        name: 'Employment',
        logo: 'IconFileCheckInActive',
        path: '/home/candidate/employment',
      },
      {
        name: 'Safeguarding Records',
        logo: '',
        path: '/home/candidate/safeguarding-records',
      },
      {
        name: 'Training Records',
        logo: '',
        path: '/home/candidate/training-records',
      },
    ],
  },

  {
    label: 'Policy',
    name: 'Policies',
    logo: 'IconFileCheckInActive',
    path: '/home/candidate/policies',
    hasChild: false,
  },

  {
    label: 'Inciedents',
    name: 'Incidents',
    logo: 'IconAlertTriangleInActive',
    path: '/home/candidate/incidents',
    hasChild: false,
  },
  {
    label: 'Whistle Blowing',
    name: 'Whistleblowing',
    logo: 'IconAnnotationAlertInActive',
    path: '/home/candidate/Whistleblowing',
    hasChild: false,
  },
  {
    label: 'Resources',
    name: 'Resources',
    logo: 'IconToolInActive',
    path: '/home/candidate/Resources',
    hasChild: false,
  },
]

export const SideBarGroupGovernorItems = [
  {
    label: 'Home',
    name: 'Home',
    logo: 'IconHomeInActive',
    path: '/home',
    hasChild: false,
  },

  {
    label: 'SCR',
    name: 'Single Central Record',
    logo: 'IconFolderInActive',
    path: '/home/scr',
    hasChild: false,
  },

  {
    label: 'Incidents',
    name: 'Incidents',
    logo: 'IconAlertTriangleInActive',
    path: '/home/incidents',
    hasChild: false,
  },
  {
    label: 'Whistle Blowing',
    name: 'Whistleblowing',
    logo: 'IconAnnotationAlertInActive',
    path: '/home/whistleblowing',
    hasChild: false,
  },
]

export const returnRole = (role: string | undefined | null) => {
  const { userPermissions } = useAuth()
  let route
  if (role == 'Admin' || role == 'Group Admin') {
    route = filterRouteItemsByPermissions(SideBarAdminItems, userPermissions)
    return route
  } else if (role == 'super') {
    route = SideBarSuperItems
    return route
  } else if (role == 'Staff' || role == 'Group Staff') {
    route = filterRouteItemsByPermissions(
      SideBarCandidateItems,
      userPermissions
    )
    return route
  } else if (
    role == 'DSL' ||
    role == 'Admin / DSL' ||
    role == 'Group DSL' ||
    role == 'Group Admin / DSL'
  ) {
    // route = SideBarLeadItems
    route = filterRouteItemsByPermissions(SideBarLeadItems, userPermissions)
    return route
  } else if (role == 'Group Governor' || role == 'Governor') {
    route = filterRouteItemsByPermissions(
      SideBarGroupGovernorItems,
      userPermissions
    )
    return route
  }
}

export const returnSubRole = (role: string | undefined | null) => {
  let route
  if (
    role == 'Admin' ||
    role == 'DSL' ||
    role == 'Admin / DSL' ||
    role == 'Group DSL' ||
    role == 'Group Admin' ||
    role == 'Group Governor' ||
    role == 'Governor' ||
    role == 'Group Staff' ||
    role == 'Group Admin / DSL'
  ) {
    route = [
      {
        name: 'My SCR Record',
        logo: 'Profile',
        path: '/home/my-scr-record',
      },
      // {
      //   name: 'Collapse',
      //   logo: 'IconArrowLeft',
      //   path: '/home/Collapse',
      // },
    ]
    return route
  }
}
